import ManifestPlugin from 'webpack-manifest-plugin';

export default (opts = {}) => (
  new ManifestPlugin({
    writeToFileEmit: true,
    ...opts
  })
);
